import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
const FAQItem = ({
  question,
  answer
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-[#D2B48C] py-4" data-id="element-98">
      <button className="flex justify-between items-center w-full text-left" onClick={() => setIsOpen(!isOpen)} data-id="element-99">
        <h3 className="text-lg font-medium text-[#8B4513]" data-id="element-100">{question}</h3>
        {isOpen ? <ChevronUpIcon className="w-5 h-5 text-[#E25822]" data-id="element-101" /> : <ChevronDownIcon className="w-5 h-5 text-[#E25822]" data-id="element-102" />}
      </button>
      {isOpen && <div className="mt-2 text-[#5E4B3C]" data-id="element-103">{answer}</div>}
    </div>;
};
const FAQ = () => {
  const faqs = [{
    question: '¿Cómo recibo los ebooks después de la compra?',
    answer: 'Inmediatamente después de tu compra, recibirás un email con los enlaces de descarga directa para todos los ebooks y bonos. Podrás descargarlos en formato PDF para leerlos en cualquier dispositivo.'
  }, {
    question: '¿Necesito experiencia previa en cocina para usar estas recetas?',
    answer: '¡No! Estas recetas están diseñadas para todos los niveles. Incluso si nunca has cocinado antes, las instrucciones paso a paso y las técnicas simplificadas te permitirán crear bocaditos impresionantes desde el primer intento.'
  }, {
    question: '¿Los ingredientes son difíciles de conseguir?',
    answer: 'Hemos diseñado las recetas para usar ingredientes que puedas encontrar en cualquier supermercado. Ocasionalmente sugerimos alternativas gourmet, pero siempre con opciones accesibles.'
  }, {
    question: '¿Cuánto tiempo necesito para preparar estas recetas?',
    answer: 'La mayoría de las recetas pueden prepararse en menos de 30 minutos. Además, el ebook de Técnicas Exprés incluye atajos profesionales para ahorrar aún más tiempo sin sacrificar calidad.'
  }, {
    question: '¿Puedo usar estas recetas para un negocio de catering?',
    answer: "¡Absolutamente! Muchos de nuestros clientes han iniciado exitosos negocios de catering con estas recetas. El bono 'De Anfitrión a Emprendedor' está específicamente diseñado para ayudarte a monetizar tus creaciones."
  }, {
    question: '¿Tienen opciones para dietas especiales?',
    answer: 'Sí, incluimos variaciones para opciones vegetarianas, veganas y sin gluten en muchas de las recetas, permitiéndote adaptarlas a diferentes necesidades dietéticas.'
  }, {
    question: '¿Qué pasa si no me gustan las recetas?',
    answer: 'Ofrecemos una garantía de satisfacción del 100%. Si no estás completamente satisfecho con tu compra, contáctanos dentro de los 7 días para un reembolso completo, sin preguntas.'
  }];
  return <section className="w-full bg-white py-16" data-id="element-104">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-105">
        <h2 className="text-3xl font-bold text-center text-[#8B4513] mb-12" data-id="element-106">
          Preguntas Frecuentes
        </h2>
        <div data-id="element-107">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-108" />)}
        </div>
        <div className="text-center mt-12" data-id="element-109">
          <a href="https://pay.hotmart.com/J101918467L?off=59zwd0bh&checkoutMode=10" className="inline-block bg-[#E25822] hover:bg-[#C64718] text-white font-bold py-2 px-6 rounded-lg text-base shadow-md transition-all transform hover:scale-105 whitespace-nowrap" data-id="element-110">
            ¡Obtener Combo Completo!
          </a>
        </div>
      </div>
    </section>;
};
export default FAQ;